import React, { useEffect } from "react";
import BaseLayout from "../../../components/BaseLayout";
import HeaderBaseLayout from "../../../components/HeaderBaseLayout";
import NoQuiz from "../NoQuiz";
import * as Assets from "../../../utils/svg_assets";
import * as PageRoutes from "../../../utils/route_pages";
import { Col, Row, Card, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { differenceDateFromNow } from "../../../utils/utilities";
import "./style.scss";

const DetailCategory = (props) => {
  const { getDetailCategory, detailCategory, pwa_setting } = props;
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    getDetailCategory(params.categoryId);
  }, []);

  const handleTakeQuiz = (id) => {
    navigate(PageRoutes.quiz + `/${params.categoryId}/${id}`);
  };

  const DetailContent = (props) => {
    return (
      <div>
        <img src={props.image} alt="logo_image" />
        <span className="detail-point mt-4">{props.text}</span>
      </div>
    );
  };

  return (
    <BaseLayout
      show_menu={pwa_setting.show_main_menu}
      isCustom={true}
      header={
        <HeaderBaseLayout
          src={Assets.iconBackWhite}
          title="Quiz - About Us"
          onClick={() => navigate(PageRoutes.quiz)}
        />
      }
    >
      <Row className="detail-category">
        {detailCategory.length > 0 ? (
          detailCategory &&
          detailCategory.map((a, index) => (
            <Col md={12} sm={12} xs={12} className="detail-wrapper" key={index}>
              <Card className="card-detail">
                <div
                  className="detail-header"
                  style={{
                    backgroundImage: `url(${
                      process.env.PUBLIC_URL + "/SKOR-Default-Quiz-Image.png"
                    })`,
                  }}
                />
                <div className="detail-body">
                  <span className="body-title">{a.name}</span>
                  <span className="body-desc">Quiz</span>
                  <Row className="mt-2">
                    <Col md={7} sm={7} xs={7}>
                      <div className="detail-quiz">
                        <DetailContent
                          image={Assets.iconGoldCoin}
                          text={`Get up to ${a.points} ${a.currency.name}`}
                        />
                        <DetailContent
                          image={Assets.iconClock}
                          text={`${differenceDateFromNow(a.end)} Days Left`}
                        />
                      </div>
                    </Col>
                    <Col md={5} sm={5} xs={5} className="text-end pt-2">
                      <Button
                        className="btn-take"
                        onClick={() => handleTakeQuiz(a.id)}
                      >
                        {a.is_completed ? "Retake" : "Take Quiz"}
                      </Button>
                    </Col>
                  </Row>
                </div>
                {a.is_completed ? (
                  <div className="progress-bar">
                    <Row className="progress-content">
                      <Col md={7} sm={7} xs={7} className="bar-symbol">
                        <div
                          className="bar-symbol-default"
                          style={{ width: `${a.quiz_score}%` }}
                        />
                      </Col>
                      <Col md={5} sm={5} xs={5} className="bar-desc">
                        <span className="percent-text">
                          Your score {a.quiz_score}%
                        </span>
                      </Col>
                    </Row>
                  </div>
                ) : null}
              </Card>
            </Col>
          ))
        ) : (
          <NoQuiz />
        )}
      </Row>
    </BaseLayout>
  );
};

const mapStateToProps = (state) => ({
  pwa_setting: state.LoginSM.login.organization_pwa_settings,
  detailCategory: state.QuizSM.detailCategory,
});

const mapDispatchToProps = (dispatch) => ({
  getDetailCategory: dispatch.QuizSM.getDetailCategory,
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailCategory);
